import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { priceFormat } from 'apps/products/utils/priceFormat';

export default function CouponView({ discount, flat, selected }) {
  const couponClassNames = classNames('fop-coupon-content', {
    selected,
    'coupon-carousel-flat': flat,
  });
  return (
    <div className="fop-coupon-wrapper">
      <div className={couponClassNames}>
        <div className="fop-coupon-price">{priceFormat({ value: discount })}</div>
      </div>
    </div>
  );
}

CouponView.propTypes = {
  discount: PropTypes.number.isRequired,
  flat: PropTypes.bool,
  selected: PropTypes.bool,
};
